// extracted by mini-css-extract-plugin
export default {"menuBar":"Sidebar_menuBar__KktT9","menuBarH1":"Sidebar_menuBarH1__JAfiR"};